'use client';
import { SlidersHorizontal } from '@phosphor-icons/react';
import { Badge } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

interface FilterPopoverProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  label?: React.ReactNode;
  className?: string;
  count?: number;
}

const FilterPopover: React.FC<FilterPopoverProps> = ({
  children,
  icon = <SlidersHorizontal size={20} />,
  label,
  className = '',
  count = 0,
}) => {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const popoverContent = popoverRef.current?.querySelector('.popover-content');
      const selectDropdown = document.querySelectorAll('.ant-select-dropdown');
      const pickerDropdown = document.querySelector('.ant-picker-dropdown');
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target as Node) &&
        !popoverContent?.contains(event.target as Node) &&
        !pickerDropdown?.contains(event.target as Node) &&
        !Array.from(selectDropdown).some((item) => item.contains(event.target as Node))
      ) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <div className='relative' ref={popoverRef}>
      {count > 0 ? (
        <Badge count={count} offset={[-3, 3]}>
          <div
            className='p-3 bg-[var(--textBlack4)] flex items-center rounded-lg cursor-pointer'
            onClick={() => setOpen(!open)}
          >
            {icon}
            {label}
          </div>
        </Badge>
      ) : (
        <div
          className='p-3 bg-[var(--textBlack4)] flex items-center rounded-lg cursor-pointer'
          onClick={() => setOpen(!open)}
        >
          {icon} {label}
        </div>
      )}

      {open && (
        <div
          className='overflow-visible xl:w-[400px] w-[350px] absolute right-0 top-full rounded-lg z-[1000] bg-white mt-2 popover-content'
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`flex flex-col gap-6 shadow-xl bg-white ${className}`}>{children}</div>
        </div>
      )}
    </div>
  );
};

export default FilterPopover;
